<template>
  <div class="space-list">
    <tab-module
      :prop="tabattributes"
      :activeName="activeSpace"
      :totalNum="totalCount"
      @updateTeamSpaces="refreshTeamSpaces"
    ></tab-module>
    <gjw-space-list-card :spaces="spaceLists" @edit-space="editSpace"></gjw-space-list-card>
    <span></span>
    <empty-content v-if="spaceLists.length === 0 && isDataAccomplish" />
    <edit-space :visible="false" ref="editSpace" @modify-success="editOK" />
  </div>
</template>

<script>
import TabModule from '@/components/layout/TabModule.vue'
import EmptyContent from '@/components/layout/EmptyContent'
import GjwSpaceListCard from '@/components/business/GjwSpaceListCard.vue'
import EditSpace from '@/views/setting/EditSpace.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SpaceList',
  components: {
    TabModule,
    GjwSpaceListCard,
    EmptyContent,
    EditSpace,
  },
  data() {
    return {
      tabattributes: {
        box_style: 'width: 1216px;margin-top: 8px;margin: auto;',
        attr: {
          cur_tab_style: 'font-weight: 700;',
          cur_slide_style: '',
          tab_content: [
            {
              anchor_point: 'DomPoint',
            },
          ],
        },
      },
      fordiv: ['页面控件1'],
      spaceLists: [],
      activeSpace: '全部空间',
      isDataAccomplish: false, // 数据是否请求完成
      page_no: 1,
      page_size: 20,
      totalCount: 0,
      member_type: '',
      query: {},
      firstUse: true,
    }
  },
  computed: {
    ...mapGetters({
      canEmitWebEventToDesktop: 'canEmitWebEventToDesktop'
    })
  },
  created() {
    this.isDataAccomplish = false
  },
  mounted() {
    this.firstUse = JSON.parse(localStorage.getItem('firstUse'))
    if (this.firstUse && this.spaceLists.length === 0) {
      this.activeSpace = '我创建的'
      this.$api.space.addTeamSpaces().then((res) => {
        if (res.data.data === 'success') {
          this.spaceLists = res.list
          // 获取空间列表
          this.getTeamSpaces()
        }
      })
      localStorage.setItem('firstUse', 'false')
    } else {
      // 获取空间列表
      this.getTeamSpaces()
      this.$tracks({ event: 'visitSpace' })
    }
    if (this.canEmitWebEventToDesktop) {
      console.info('before emitting event to desktop: space-list-comp-mounted')
      this.$desktopClient.EmitWebEvent({ eventName: 'space-list-comp-mounted' })
      console.info('after emitting event to eventBus: space-list-comp-mounted')
    }
  },
  methods: {
    refreshTeamSpaces(index) {
      this.spaceLists = []
      this.page_no = 1
      this.isDataAccomplish = false
      this.$tracks({ event: 'newSpace' })
      this.getTeamSpaces(index)
    },
    // 获取空间列表
    getTeamSpaces(index) {
      if (index === 0) return
      if (
        this.spaceLists.length >= this.totalCount &&
        this.totalCount !== 0 &&
        index !== 'add'
      ) {
        return
      }
      if (index && index !== 'add') {
        this.page_no = index
      } else {
        this.page_no = 1
      }
      if (this.activeSpace === '全部空间') {
        this.query = {
          member_type: this.member_type,
          page_no: this.page_no,
          page_size: this.page_size,
        }
      }
      if (this.activeSpace === '我创建的') {
        this.query = {
          member_type: 'CREATOR',
          page_no: this.page_no,
          page_size: this.page_size,
        }
      }
      if (this.activeSpace === '我参与的') {
        this.query = {
          member_type: 'MEMBER',
          page_no: this.page_no,
          page_size: this.page_size,
        }
      }
      this.$api.space.getTeamSpaces(this.query).then((res) => {
        this.isDataAccomplish = true
        this.totalCount = res.totalCount
        if (this.query.page_no !== 1) {
          this.spaceLists = [...this.spaceLists, ...res.list]
        } else {
          this.spaceLists = res.list
        }
      })
    },
    // Tab切换
    handleChildMessage(msg) {
      this.spaceLists = []
      this.page_no = 1
      this.activeSpace = msg
      this.isDataAccomplish = false
      this.getTeamSpaces()
    },
    // 编辑空间列表
    editSpace(spaceId) {
      this.$refs.editSpace.openDialog(spaceId)
    },
    // 编辑空间列表
    editOK(res) {
      const spaces = this.spaceLists.filter((item) => item.id === res.id)
      if (spaces && spaces.length > 0) {
        spaces[0].name = res.name
        spaces[0].coverUrl = res.coverUrl
      }
    },
  },
}
</script>
